export const FIRST_STATS_STATUS = {
    LOADING: 'loading',
    READY: 'ready',
    RELAUNCH: 'relaunch',
    RELAUNCH_FAILED: 'relaunch_failed'
} as const;

export type FirstStatsStatusType = (typeof FIRST_STATS_STATUS)[keyof typeof FIRST_STATS_STATUS];
